const firebaseConfig = {
  apiKey: "AIzaSyD3ayDlybJZS0EfPuS_nUmL5CzfwFgEC5U",
  authDomain: "vue-muso-ninjas.firebaseapp.com",
  projectId: "vue-muso-ninjas",
  storageBucket: "vue-muso-ninjas.appspot.com",
  messagingSenderId: "574213452857",
  appId: "1:574213452857:web:32687bc0e3e0cbbf3d49e8",
};

export default firebaseConfig;
